import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { uploadPdfs } from '../actions';

class FileSelectScreen extends Component {
  onDrop = acceptedFiles => {
    this.props.uploadPdfs(acceptedFiles, this.props.Templates, res => {
      alert('Finished Processing');
    });
  };

  // showing hint message for file dropping
  renderChildren({ isDragActive, isDragReject }) {
    if (isDragReject) {
      return <h4 className="drop-message">wrong file type</h4>;
    } else if (isDragActive) {
      return <h4 className="drop-message">accept and analyze</h4>;
    } else {
      return <h4 className="drop-message">Drag and drop some files on me, or click to select.</h4>;
    }
  }

  render() {
    return (
      <div className="imitate-screen">
        <Dropzone
          onDrop={this.onDrop}
          multiple
          accept="application/pdf"
          className="dropzone"
          activeClassName="dropzone-active"
          rejectClassName="dropzone-reject">
          {this.renderChildren}
        </Dropzone>
      </div>
    );
  }
}

FileSelectScreen.propTypes = {
  Templates: PropTypes.array,
  uploadPdfs: PropTypes.func
};

// map the state received from reducer to props
function mapStateToProps(state) {
  return { Vocabularies: state.Vocabularies ? state.Vocabularies.word_table_by_gram : {} };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ uploadPdfs: uploadPdfs }, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FileSelectScreen);



// WEBPACK FOOTER //
// ./src/containers/FileSelectScreen.js